export const PICKUP_DATE = 'Pickup Date'
export const PICKUP = 'Pickup'
export const DELIVERY = 'Delivery'
export const LFD = 'LFD'
export const VESSEL_ETA = 'Vessel ETA'
export const VESSEL_CUT = 'Vessel Cut'
export const DELIVERY_DATE = 'Delivery Date'
export const APPT_PENDING = 'APPT Pending'
const STOP_TYPE_PICKUP = 0

export const MODE_FTL = 'default'

function buildResponseObject(opts, stop) {
  return {
    ...opts,
    isPickup: opts.isPickup || false,
    isDelivery: opts.isDelivery || false,
    appointmentLabel: opts.appointmentLabel || '',
    viewMode: opts.viewMode || MODE_FTL,
    facilityNumber: opts.facilityNumber >= 0 ? opts.facilityNumber : stop.stop_index || null,
  }
}

export const defaultPickup = {
  isPickup: true,
  pickupDeliveryLabel: PICKUP,
  appointmentLabel: PICKUP_DATE,
}

export const defaultDelivery = {
  isDelivery: true,
  pickupDeliveryLabel: DELIVERY,
  appointmentLabel: DELIVERY_DATE,
}

export const badNotFound = buildResponseObject({
  pickupDeliveryLabel: 'not found',
  appointmentLabel: 'not found',
  facilityNumber: 0,
})

function getStopInfo({ stop }) {
  const { stop_index: stopIndex, type: stopType } = stop

  // FTL
  if (stopType) {
    if (stopType === STOP_TYPE_PICKUP || stopType === PICKUP.toLowerCase()) {
      return buildResponseObject(defaultPickup, stop)
    } else {
      return buildResponseObject(defaultDelivery, stop)
    }
  }

  if (stopIndex === 0) return buildResponseObject(defaultPickup, stop)

  if (stopIndex > 0) return buildResponseObject(defaultDelivery, stop)

  return badNotFound
}

export { getStopInfo }
